<template>
  <vs-table multiple v-model="selected" ref="table" :data="documents" :sst="true" @input="console.log($event)">
    <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
    >
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        <vs-button class="mr-3" iconPack="feather" icon="icon-file-plus" type="border" @click="printAll">Print All Label PDF</vs-button>
        <vs-button iconPack="feather" icon="icon-truck" type="border" @click="markAsSentConfirm">Mark All as Sent</vs-button>
      </div>
      <!-- ACTIONS -->
      <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
      >
        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
          <span class="mr-2"> Actions </span>
          <feather-icon
              icon="ChevronDownIcon"
              svgClasses="h-4 w-4"
          />
        </div>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="markSentToStorage" :disabled="!selected.length">
            <span>Mark Sent to Storage</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="pdf" :disabled="!selected.length">
            <span>Create Label PDF</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="deleteConfirm" :disabled="!selected.length">
            <span>Delete</span>
          </vs-dropdown-item>

        </vs-dropdown-menu>
      </vs-dropdown>
    </div>


    <template slot="thead">
      <vs-th>Client</vs-th>
      <vs-th>Storage ID</vs-th>
      <vs-th>Reference ID</vs-th>
      <vs-th>Document Type</vs-th>
      <vs-th>Date Added</vs-th>
      <vs-th>Signature Date</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="tr.user">
          <span v-if="tr.user">{{ tr.user.user_detail.full_name }}</span><br>
          <small>{{ tr.user.email }}</small>
        </vs-td>
        <vs-td :data="tr.storage_id">{{ tr.storage_id }}</vs-td>
        <vs-td :data="tr.reference_number">{{ tr.reference_number }}</vs-td>
        <vs-td :data="tr.username">
          {{ typeLabel(tr) }}
        </vs-td>
        <vs-td :data="tr.date_created">
          <span v-if="tr.date_created">{{ formatDateAndTime(tr.date_created) }}</span>
        </vs-td>
        <vs-td :data="tr.signed_date">
          <span v-if="tr.signed_date">{{ formatDate(tr.signed_date) }}</span>
        </vs-td>

      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
  import { createPdf } from '@/mixins/createPdf'
  import { textFormat } from '@/mixins/textFormat'
  import { tableHelpers } from '@/mixins/tableHelpers'
  import { documentActions} from "@/mixins/documentActions";

  export default {
    name: 'RecentlyCreateTable',
    mixins: [textFormat, tableHelpers, documentActions, createPdf],
    props: ['data', 'itemsPerPage'],
    computed: {
      documents () {
        return this.data.data
      }
    },
    data () {
      return {
        selected: [],
        searchQuery: '',
        status: 'All'
      }
    },
    methods: {
      handleSort (key, active) {
        this.$emit('sort', key, active)
      },
      changePage (event) {
        this.$emit('changePage', event)
      },
      markAsSentConfirm () {
        if (!this.documents.length ) {
          this.$vs.notify({
            title:'Error',
            text:'No document to mark as sent',
            color:'danger'
          })
          return
        }
        this.$vs.dialog({
          type:'confirm',
          color: 'success',
          title: `Confirm`,
          text: 'Mark all recently recently documents as \'sent to storage\'',
          accept:this.markAsSentAll
        })
      },
      markAsSentAll () {
        this.selected = this.documents
        this.markSentToStorage()
      },
      printAll () {
        this.selected = this.documents
        this.pdf()
      },
      deleteConfirm () {
        this.$vs.dialog({
          type:'confirm',
          color: 'success',
          title: `Confirm`,
          text: 'Delete selected documents',
          accept:this.deleteSentToStorage
        })
      }
    }
  }
</script>
